import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '../assets/images/close.svg'

const CustomModal = ({ show, onHide, subtitle, title, children, showCloseButton, footerButtons }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      {(title || showCloseButton) && (
        <Modal.Header className='border-0 px-5 position-relative'>
          <div className="">
            {title && <Modal.Title className='pt-3'>{title}</Modal.Title>}
            {subtitle && <p className='mb-0 subtitle'>{subtitle}</p>}
          </div>
          {showCloseButton && (
            <img
              src={CloseIcon}
              alt="Close"
              onClick={onHide}
              style={{
                position: 'absolute',
                top: 40,
                right: 50,
                width: 15,
                height: 15,
                cursor: 'pointer',
              }}
            />
          )}
        </Modal.Header>
      )}

      <Modal.Body className='px-5 p-0'>
        {children}
      </Modal.Body>

      {footerButtons !== false && (
        <Modal.Footer className='border-0 px-5 mb-3'>
          {footerButtons || (
            <>
              <Button variant="secondary" onClick={onHide}>
                Close
              </Button>
            </>
          )}
        </Modal.Footer>
      )
      }
    </Modal>
  );
};

export default CustomModal;
